export const aboutData = {
    title: "About Me",
    description1: "Automation-focused engineer with hands-on experience building workflows in n8n, integrating APIs with Claude Code and ChatGPT, and managing digital operations in Notion and Google Workspace.",
    description2: "Background in software development (Python, Java Spring, Docker) and system administration enables me to design robust automations that save founders hours each week. High agency, detail-oriented, and ready to support global entrepreneurs.",
    image: 2
}